import {AppClient} from 'openapi'
import {CustomAxiosHttpRequest} from './client'
import store from '../redux/store'
import sideNotification from '../app/helper/sideNotification'
import {isExpired, decodeToken} from 'react-jwt'
import * as authHelper from '../app/modules/auth/core/AuthHelpers'
import {MarvelToast} from 'app/helper/MarvelToast'
import {IsApiResponseError, IsErrorResponse} from 'app/core/_core'
// import {ErrorResponse} from 'app/core/_core'

const ignoreTokenCheckUrls = ['/auth/login', 'authentication/forgot-password']

const API_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_DEVELOPMENT_URL : process.env.REACT_APP_API_PRODUCTION_URL
const TIMEOUT = process.env.REACT_APP_TIMEOUT
const instance = new AppClient(
  {
    BASE: API_URL,
    timeout: TIMEOUT, // timeout dalam milidetik
  },
  CustomAxiosHttpRequest
)

instance.request.axiosInstance.interceptors.request.use(
  async function (config) {
    const {
      auth: {authToken},
    } = store.getState()
    var _token = authToken
    // console.log("config", config)
    // // config.headers['Content-Type'] = 'application/json';
    // if (config.headers['Content-Type'] !== "application/json") {
    //     config.headers['Content-Type'] =
    // }

    if (config.data && config.data['params']) {
      config.params = config.data['params']
    }

    if (ignoreTokenCheckUrls.includes(config.url)) {
      return config
    }

    if (!decodeToken(_token)) {
      await logout()
    }

    if (isExpired(_token)) {
      // await refreshToken(_token).then(async (result) => {
      //   if (result.success) {
      //     _token = result.data
      //     config.headers['Authorization'] = 'Bearer ' + result.data
      //   } else {
      //     await logout()
      //   }
      // })

      await logout()
    } else {
      config.headers['Authorization'] = 'Bearer ' + _token
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

instance.request.axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 400) {
      return Promise.resolve(response)
    } else {
    }
  },
  async (r) => {
    console.log('T', r)
    var method = r?.response?.config?.method ?? ''
    switch (r.response.status) {
      case 400:
        if (r?.response?.data?.error?.includes('already exists')) {
          MarvelToast.error('Data yang kamu masukkan sudah terdaftar')
        } else if (r?.response?.data?.error?.includes('notNull Violation')) {
          MarvelToast.error(r?.response?.data?.error)
        }
        return Promise.reject(r.response.data)
      case 401:
        if (r.response.config.url.includes('auth/login')) {
          return Promise.reject(r?.response?.data?.message ?? 'Password yang kamu masukkan salah')
        } else {
          logout()
        }
        break
      case 403:
        console.log(r)
        if (IsApiResponseError(r?.response?.data)) {
          MarvelToast.error(r?.response?.data?.error)
        } else if (IsErrorResponse(r)) {
          MarvelToast.error(r?.response?.data?.message)
        }

        return Promise.reject(r?.response)
      case 404:
        // if (((r.response?.config?.method ?? "") as string).toLocaleLowerCase() === "delete")

        if (method.toLowerCase() === 'delete') {
          return Promise.reject(false)
        } else {
          if (r.response.config.url.includes('auth/login')) {
            return Promise.reject(r?.response?.data?.message ?? 'Akun tidak ditemukan!')
          } else {
            console.log(r?.response)
            if (typeof r?.response?.data?.message == 'string') {
              return Promise.reject(r?.response?.data)
            } else {
              sideNotification.open('Terjadi Kesalahan!', r?.response?.data?.message ?? r?.message ?? 'Endpoint could not be found.', false)
            }
          }
        }
        break
      default:
        // sideNotification.open('Oopss!', 'Ada sesuatu yang salah!', false)
        break
    }
    return Promise.reject(false)

    // if (r.response.status === 401) {
    //   if (r.response.config.url.includes('auth/login')) {
    //     return Promise.reject(r?.response?.data?.message ?? 'Password yang kamu masukkan salah')
    //   }
    // } else if (r.response.status === 404) {
    //   if (r.response.config.url.includes('auth/login')) {
    //     return Promise.reject(r?.response?.data?.message ?? 'Akun tidak ditemukan!')
    //   }
    // }
    // if (r.response.config.url.includes('auth/login')) {
    //   if (r.response.status === 401) {
    //     return Promise.reject(r?.response?.data?.message ?? 'Password yang kamu masukkan salah')
    //   } else if (r.response.status === 404) {
    //     return Promise.reject(r?.response?.data?.message ?? 'Akun tidak ditemukan!')
    //   }
    // } else {
    //   switch (r.response.status) {
    //     case 400:
    //       return Promise.reject(r.response.data)
    //       break
    //     case 401:
    //       logout()
    //       break
    //     case 404:
    //       sideNotification.open('Someting went wrong!', r?.response?.data?.message ?? r?.message ?? 'Endpoint could not be found.', false)
    //       break
    //     default:
    //       sideNotification.open('Oopss!', 'Ada sesuatu yang salah!', false)
    //       break
    //   }
    // }
    // if (r.response && r.response.data) {
    //   return Promise.reject(r.response.data)
    // }
  }
)

// const refreshToken = async (token) => {
//   return new Promise((resolve) => {
//     fetch(`${API_URL}authentication/refresh-token`, {
//       method: 'POST',
//       // mode: 'cors',
//       // cache: 'no-cache',
//       // credentials: 'same-origin',
//       headers: {
//         'Content-Type': 'application/json',
//         Device: 'device',
//         Authorization: 'Bearer ' + token,
//       },
//     })
//       .then((res) => res.json())
//       .then((res) => {
//         const {success, data} = res
//         if (success) {
//           store.dispatch(actions.setToken(data))
//         }
//         resolve(res)
//       })
//       .catch(async () => {
//         await logout()
//         window.location.reload()
//       })
//   })
// }

const logout = async () => {
  authHelper.logout()
}

export default instance
